export const agencyValidator = (values: any) => {
  const errors: Record<string, any> = {}

  if (values.price < 0) errors.price = 'Price should be greater or equal than zero'

  if (values.price == null) errors.price = 'Price is required'

  if (!values.currency) errors.currency = 'Currency is required'

  return errors
}
